export default __webpack_public_path__ + "static/media/company.88583d9e.svg";